export default (doc) => {
  const lang = doc.lang.substring(0, 2);

  if (doc.type === "home") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}`;
    }
    return "/";
  }

  if (doc.type === "services") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/dienstleistungen`;
    }
    return "/services";
  }

  if (doc.type === "team") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/team`;
    }
    return "/equipe";
  }

  if (doc.type === "about_history") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/ueber-uns`;
    }
    return "/a-propos";
  }

  if (doc.type === "testimonials_home") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/erfahrungsberichte`;
    }
    return "/temoignages";
  }

  if (doc.type === "articles") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/artikel/${doc.uid}`;
    }
    return `/article/${doc.uid}`;
  }

  if (doc.type === "jobs") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/jobs`;
    }
    return "/emplois";
  }

  if (doc.type === "contact") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/kontakt`;
    }
    return "/contact";
  }

  if (doc.type === "myfisco") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/myfisco`;
    }
    return "/myfisco";
  }

  if (doc.type === "articles_home") {
    if (lang === "de") {
      return `/${doc.lang.substring(0, 2)}/alle-artikel`;
    }
    return "/articles";
  }

  return "/";
};
